<h2 mat-dialog-title>
  {{ 'VISIBILITY_INFO_DIALOG.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    @if (namespaceName$ | async; as namespaceName) {
      <span>{{ 'VISIBILITY_INFO_DIALOG.INTRO' | translate }}</span>
      <ul class="unordered-list">
        <li>
          <b>{{ 'VISIBILITY_INFO_DIALOG.PUBLIC_TITLE' | translate: { namespaceName: namespaceName } }}</b>
          &nbsp;{{ 'VISIBILITY_INFO_DIALOG.PUBLIC_DESCRIPTION' | translate: { namespaceName: namespaceName } }}
        </li>
        <br>
        <li>
          <b>{{ 'VISIBILITY_INFO_DIALOG.UNLISTED_TITLE' | translate: { namespaceName: namespaceName } }}</b>
          &nbsp;{{ 'VISIBILITY_INFO_DIALOG.UNLISTED_DESCRIPTION' | translate: { namespaceName: namespaceName } }}
        </li>
        <br>
        <li>
          <b>{{ 'VISIBILITY_INFO_DIALOG.PRIVATE_TITLE' | translate: { namespaceName: namespaceName } }}</b>
          &nbsp;{{ 'VISIBILITY_INFO_DIALOG.PRIVATE_DESCRIPTION' | translate: { namespaceName: namespaceName } }}
        </li>
      </ul>
    } @else {
      <!-- loading state -->
      <div class="stencil-shimmer stencil-intro"></div>
      <div class="stencil-shimmer stencil-list-item"></div>
      <div class="stencil-shimmer stencil-list-item"></div>
      <div class="stencil-shimmer stencil-list-item"></div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close tabIndex="-1">
    {{ 'COMMON.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
